import { Component, OnInit } from '@angular/core';
import { ExcelService } from '../../../services/excel.service';
import { ReportesService } from '../../../services/reportes.service';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Params, ActivatedRoute, Router } from '@angular/router';
import { AlertasModales } from '../../../helpers/alertasModales';
import { Helper } from '../../../helpers/helper';
import { DatePipe, LowerCasePipe } from '@angular/common';
import { ExcelTitle, ExcelColumns, ExcelRows } from '../../../interfaces/excel.interface';
import { EmpleadosServicio } from '../../../services/empleado.service';
declare const $: any;

const ID_PAGINA = 19;

@Component({
  selector: 'app-data-credito',
  templateUrl: './data-credito.component.html',
  styleUrls: ['./data-credito.component.css']
})
export class DataCreditoComponent implements OnInit {
  datacredito = [];
  loaded = false;
  exportando = false;
  loading = false;
  now = new Date(this.helper.getDate());
  page = 1;
  limit = 50;
  offset = 0;
  size = 0;
  quitarCliente = 0;
  legal = 90;
  castigadas = 120;
  ce = '';
  fecha_procesar: NgbDateStruct;
  fecha_saldos: NgbDateStruct;
  columnsSort = [];
  private columnsServer = [];
  incluir = [
    { label: 'Saldado', value: 1, checked: 0 },
    { label: 'Normal', value: 2, checked: 0 },
    { label: 'Atraso', value: 3, checked: 0 },
    { label: 'Legal', value: 4, checked: 0 },
    { label: 'Castigado', value: 5, checked: 0 },
  ];
  clientesSeleccionado = [];
  
  constructor(
    private excelService: ExcelService,
    private reporteService: ReportesService,
    private route: ActivatedRoute,
    private modals: AlertasModales,
    private helper: Helper,
    private router: Router,
    private empleadoService: EmpleadosServicio) {
    if (empleadoService.datosEmpleado.tipo_empleado !== 3 && !empleadoService.paginasAsignadas.filter(page => page.ID_PAGINA == ID_PAGINA).length) {
      this.router.navigate(['/404']);
    }
    this.initColumns();
    this.fecha_procesar = {year: this.now.getFullYear(), month: this.now.getMonth() + 1, day: this.now.getDate() };
  }

  ngOnInit() {
    this.verificarQueryString();
  }

  private initDataCredito() {
    this.loading = true;
    let fecha_procesar = '';
    let fecha_saldos = '';
    if (this.fecha_procesar !== undefined && this.fecha_procesar !== null && this.fecha_procesar.year !== null) {
      fecha_procesar = `${this.fecha_procesar['year']}-${this.fecha_procesar['month']}-${this.fecha_procesar['day']}`;
    }

    if (this.fecha_saldos !== undefined && this.fecha_saldos !== null && this.fecha_saldos.year !== null) {
      fecha_saldos = `${this.fecha_saldos['year']}-${this.fecha_saldos['month']}-${this.fecha_saldos['day']}`;
    }
    const incluir = this.incluir.filter(i => i.checked).map(i => i.value).join();
    this.reporteService.obtenerDataCredito(
      this.ce,
      fecha_procesar,
      fecha_saldos,
      this.legal,
      this.castigadas,
      this.quitarCliente,
      incluir,
      this.limit,
      this.offset,
      JSON.stringify(this.columnsServer)
    ).subscribe((res: any) => {
      this.datacredito = res.data;
      this.size = res.total_items;
      setTimeout(() => { this.loaded = true; this.loading = false; }, 1);
    });
  }
  private initColumns(): void {
    this.columnsSort = [
      {
        label: 'Nombre',
        column: `CONCAT(c.nombre, ' ', c.apellido)`,
        order: ''
      },
      {
        label: 'Cédula-RNC',
        column: 'c.cedula',
        order: ''
      },
      {
        label: 'Dirección',
        column: 'c.direccion',
        order: ''
      },
      {
        label: 'Teléfono 1',
        column: 'c.telefono',
        order: ''
      },
      {
        label: 'Teléfono 2',
        column: 'c.celular',
        order: ''
      },
      {
        label: 'Número préstamo',
        column: `p.ID_PRESTAMO`,
        order: ''
      },
      {
        label: 'Fecha apertura',
        column: 'p.fecha_prestamo',
        order: ''
      },
      {
        label: 'Monto formalizado',
        column: 'p.capital',
        order: ''
      },
      {
        label: 'Monto cuota',
        column: 'monto_cuotas',
        order: ''
      },
      {
        label: 'Balance al día',
        column: 'balance_pendiente',
        order: ''
      },
      {
        label: 'Monto atraso',
        column: `balance_atraso`,
        order: ''
      },
      // {
      //   label: 'Dias atraso',
      //   column: `dias_vencido`,
      //   order: ''
      // },
      {
        label: 'Fecha Vencimiento',
        column: `fecha_vence`,
        order: ''
      },
      {
        label: 'Último pago',
        column: `ultimo_pago`,
        order: ''
      },
    ];
  }

  filtrarDatacredito() {

    this.page = 1;
    this.offset = 0;
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    delete queryParams['cliente'];
    delete queryParams['fechaProcesar'];
    delete queryParams['fechaSaldos'];
    delete queryParams['quitarCliente'];
    delete queryParams['cuentasLegal'];
    delete queryParams['cuentasCastigadas'];
    delete queryParams['incluir'];
    delete queryParams['limite'];
    if (this.ce) {
      queryParams['cliente'] = this.ce;
    }
    if (this.fecha_procesar !== undefined && this.fecha_procesar !== null && this.fecha_procesar.year !== null) {
      queryParams['fechaProcesar'] = `${this.fecha_procesar['year']}-${this.fecha_procesar['month']}-${this.fecha_procesar['day']}`;
    }
    if (this.fecha_saldos !== undefined && this.fecha_saldos !== null && this.fecha_saldos.year !== null) {
      queryParams['fechaSaldos'] = `${this.fecha_saldos['year']}-${this.fecha_saldos['month']}-${this.fecha_saldos['day']}`;
    }
    if (this.legal) {
      queryParams['cuentasLegal'] = this.legal;
    }
    if (this.castigadas) {
      queryParams['cuentasCastigadas'] = this.castigadas;
    }
    const incluirChecked = this.incluir.filter(i => i.checked);
    if (incluirChecked.length > 0) {
      queryParams['incluir'] = incluirChecked.map(i => i.label.toLowerCase()).join();
    }

    if (this.limit) {
      queryParams['limite'] = this.limit;
    }
    this.router.navigate(['./reporte/datacredito'], { queryParams: queryParams });
  }

  private verificarQueryString(): void {
    this.route.queryParams.subscribe(params => {
      if (params) {
        this.columnsServer = [];
        // tslint:disable-next-line:forin
        for (const columnParams in params) {
          for (const column of this.columnsSort) {
            if (column.label.replace(/\s/g, '').toLowerCase() === columnParams.replace('order', '')) {
              if (params[columnParams].toLowerCase() === 'asc' || params[columnParams].toLowerCase() === 'desc') {
                column.order = params[columnParams].toLowerCase();
                this.columnsServer.push(column);
                break;
              }
            }
          }
        }

        if (params.limite) {
          this.limit = params.limite;
        }

        if (params.fechaProcesar) {
          const year = parseFloat(params.fechaProcesar.split('-')[0]);
          const month = parseFloat(params.fechaProcesar.split('-')[1]);
          const day = parseFloat(params.fechaProcesar.split('-')[2]);
          if (!isNaN( year ) && !isNaN( month ) && !isNaN( day )) {
            this.fecha_procesar = { year, month, day };
          } else {
            this.fecha_procesar = {
              year: null,
              month: null,
              day: null
            };
          }
        }

        if (params.fechaSaldos) {
          const year = parseFloat(params.fechaSaldos.split('-')[0]);
          const month = parseFloat(params.fechaSaldos.split('-')[1]);
          const day = parseFloat(params.fechaSaldos.split('-')[2]);
          if (!isNaN( year ) && !isNaN( month ) && !isNaN( day )) {
            this.fecha_saldos = { year, month, day };
          } else {
            this.fecha_saldos = {
              year: null,
              month: null,
              day: null
            };
          }
        }

        if (params.cliente) {
          this.ce = params.cliente;
        }

        if (params.page && !isNaN(params.page)) {
          this.page = parseFloat(params.page);
          this.offset = this.limit * (this.page - 1);
        }

        this.legal = !isNaN(params.cuentasLegal) ? params.cuentasLegal : this.legal;
        this.castigadas = !isNaN(params.cuentasCastigadas) ? params.cuentasCastigadas : this.castigadas;

        if (params.incluir) {
          for (const incluir of this.incluir) {
            for (const paramsIncluir of params.incluir.split(',')) {
              if (paramsIncluir.toLowerCase() === incluir.label.toLowerCase()) {
                incluir.checked = 1;
              }
            }
          }
        } else {
          for (const incluir of this.incluir) {
            incluir.checked = 1;
          }
        }

        this.initDataCredito();
      }
    });
  }

  orderTable(column) {
    if (!column.order) {
      column.order = 'desc';
    } else {
      column.order = column.order === 'desc' ? 'asc' : 'desc';
    }
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    delete queryParams[`order${column.label.replace(/\s/g, '').toLowerCase()}`];
    queryParams[`order${column.label.replace(/\s/g, '').toLowerCase()}`] = column.order;
    this.router.navigate(['./reporte/datacredito'], { queryParams: queryParams });
  }

  descartarCliente() {
    if (this.clientesSeleccionado.length > 0) {
      this.reporteService.removerClienteDataCredito(this.clientesSeleccionado.map(item => item.ID_CLIENTE), this.quitarCliente)
      .subscribe(() => {
        this.initDataCredito();
      });
    }
  }

  seleccionarCliente(item) {
    this.clientesSeleccionado = [...this.clientesSeleccionado, item];
  }

  loadPage(page: number) {
    this.page = page;
     this.offset = this.limit * (this.page - 1);
     const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
     queryParams['page'] = page;
    this.router.navigate(['./reporte/datacredito'], { queryParams: queryParams });
  }

  listaExcluidos() {
    this.modals.recuperarClienteDatacreditoNgbModal().then(() => {
      this.initDataCredito();
    });
  }

  exportar() {
    this.exportando = true;
    const titulo: ExcelTitle = {
      title: 'Hoja de Resumen',
      font: { name: 'Arial', size: 16, underline: 'double', bold: true }
    };
    const columns: ExcelColumns =  {
      // tslint:disable-next-line:max-line-length
      columns: ['NOMBRE', 
                'CEDULA-RNC', 
                'DIRECCÍON', 
                'TELEFONO 1', 
                'TELEFONO 2', 
                'NÚMERO DE PRÉSTAMO', 
                'FECHA APERTURA', 
                'MONTO FORMALIZADO', 
                'MONTO CUOTA',
                'ESTADO', 
                'ATRASO DE 1 A 30 DIAS',
                'ATRASO DE 31 A 60 DIAS',
                'ATRASO DE 61 A 90 DIAS',
                'ATRASO DE 91 A 120 DIAS',
                'ATRASO DE 121 A 150 DIAS',
                'ATRASO DE 151 A 180 DIAS',
                'ATRASO DE 181 O MAS',
                'BALANCE AL DÍA', 
                'MONTO EN ATRASO',
                'FECHA DE VENCIMIENTO', 
                'FECHA ÚLTIMO PAGO', 
                'TIPO DE PRÉSTAMO'],
      styles: {
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFFF00' },
          bgColor: { argb: 'FFFF00' }
        },
        border: {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        }
      },
      columnOptions: [
        { key: 1, properties: { width: 40 } },
        { key: 2, properties: { width: 15 } },
        { key: 3, properties: { width: 60 } },
        { key: 4, properties: { width: 15 } },
        { key: 5, properties: { width: 15 } },
        { key: 6, properties: { width: 23 } },
        { key: 7, properties: { width: 19 } },
        { key: 8, properties: { width: 23 } },
        { key: 9, properties: { width: 15 } },
        { key: 10, properties: { width: 10 } },
        { key: 11, properties: { width: 23 } },
        { key: 12, properties: { width: 23 } },
        { key: 13, properties: { width: 23 } },
        { key: 14, properties: { width: 23 } },
        { key: 15, properties: { width: 23 } },
        { key: 16, properties: { width: 23 } },
        { key: 17, properties: { width: 23 } },
        { key: 18, properties: { width: 20 } },
        { key: 19, properties: { width: 20 } },
        { key: 20, properties: { width: 22 } },
        { key: 21, properties: { width: 22 } },
        { key: 22, properties: { width: 22 } },
        
      ]
    };
    const data: ExcelRows = {
      rows: []
    };
    const datePipe = new DatePipe('en-US');
    const lowerCasePipe = new LowerCasePipe();
    let fecha_procesar = '';
    let fecha_saldos = '';
    if (this.fecha_procesar !== undefined && this.fecha_procesar !== null && this.fecha_procesar.year !== null) {
      fecha_procesar = `${this.fecha_procesar['year']}-${this.fecha_procesar['month']}-${this.fecha_procesar['day']}`;
    }

    if (this.fecha_saldos !== undefined && this.fecha_saldos !== null && this.fecha_saldos.year !== null) {
      fecha_saldos = `${this.fecha_saldos['year']}-${this.fecha_saldos['month']}-${this.fecha_saldos['day']}`;
    }
    const incluir = this.incluir.filter(i => i.checked).map(i => i.value).join();
    this.reporteService.obtenerDataCredito(
      this.ce,
      fecha_procesar,
      fecha_saldos,
      this.legal,
      this.castigadas,
      this.quitarCliente,
      incluir,
      0,
      0,
      JSON.stringify(this.columnsServer)
    ).subscribe((res: any) => {
      
      
      for (const row of res.data) {
        // tslint:disable-next-line:max-line-length
      
        data.rows.push(
        [
          this.helper.capitalizeFirstLetter( lowerCasePipe.transform( row.cliente) ),
          row.cedula,
          this.helper.capitalizeFirstLetter( lowerCasePipe.transform( row.direccion) ),
          row.telefono,
          row.celular,
          row.ID_PRESTAMO,
          datePipe.transform(row.fecha_prestamo, 'dd/MM/yyyy'),
          row.capital,
          row.monto_cuotas,
          row.estado === 3 ? 'S' : ( row.dias_vencido <= 0 ? 'N' :
                                      (row.dias_vencido <= this.legal ? 'A' :
                                          (row.dias_vencido <= this.castigadas ? 'L' : 'C')
                                      )
                                  ),
          row.dias_vencido >0 && row.dias_vencido <= 30 ? row.balance_atraso : null,
          row.dias_vencido >30 && row.dias_vencido <= 60 ? row.balance_atraso : null,
          row.dias_vencido >60 && row.dias_vencido <= 90 ? row.balance_atraso : null,
          row.dias_vencido >90 && row.dias_vencido <= 120 ? row.balance_atraso : null,
          row.dias_vencido >120 && row.dias_vencido <= 150 ? row.balance_atraso : null,
          row.dias_vencido >150 && row.dias_vencido <= 180 ? row.balance_atraso : null,
          row.dias_vencido >180  ? row.balance_atraso : null,
          row.balance_pendiente,
          row.balance_atraso,
          datePipe.transform(row.fecha_vence, 'dd/MM/yyyy'),
          datePipe.transform(row.ultimo_pago, 'dd/MM/yyyy'),
          'M'
          // row.tipoPlazo === 7 ? 'Semanal': (
          //   row.tipoPlazo === 30 ? 'Mensual' : (
          //     row.tipoPlazo === 365 ? 'Anual' : 'Diario'
          //   )
          // ),
        ]
        );
      }
            
      this.excelService.generateExcel(titulo, columns, data, {state: 'frozen', xSplit: 1, ySplit: 1, topLeftCell: 'G2', activeCell: 'A2'}).then(() => this.exportando = false);
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/reportes/data-credito/data-credito.component.ts